import { format as fnsFormat, parseISO } from "date-fns";
import PAGE_CONFIG from "../../config/page";
export type TApiDatetime = string;

export const parse = (
  value: TApiDatetime | null | undefined
): Date | undefined => {
  if (!value) return undefined;
  try {
    const iso = parseISO(value);
    if (!isNaN(iso.getTime())) return iso;
    const fallback = new Date(value);
    return isNaN(fallback.getTime()) ? undefined : fallback;
  } catch {
    return undefined;
  }
};

export const format = (
  value: TApiDatetime | null | undefined,
  pattern: string = PAGE_CONFIG.DATE_FORMAT
): string => {
  const date = parse(value);
  if (!date) return "";
  try {
    return fnsFormat(date, pattern);
  } catch {
    return "";
  }
};
